<template lang="pug">
mein-projekt

</template>

<script>
import MeinProjekt from '../mein-projekt'

export default {
  props: ['extra'],
  name: 'extra-mein-projekt',
  components: {
    MeinProjekt
  }
}
</script>
